@if (show() && profile$ | async; as profile) {
  <div class="wallet-data">
    <hr class="divider-light-gray-fat" />
    <!-- Company details -->
    <section class="sepa-details">
      <div class="sepa-details-list">
        <bp-input
          [label]="'reference_number' | translate"
          [value]="paymentReference"
          readonly
          disabled
          class="reference-number-bp-input">
          <a
            right
            class="action-button"
            [copyToClipboard]="paymentReference"
            [copyInfo]="'copied_reference_to_clipboard' | translate">
            <span class="bpi__icon-clipboard"></span>
          </a>
          <bp-info class="reference-info" full>{{ "reference_number_description" | translate }}</bp-info>
        </bp-input>
        @if (profile.fullName !== '') {
          <bp-input
            [label]="'sepa_from' | translate"
            [value]="profile.fullName"
            readonly
            disabled
            >
            <a
              right
              class="action-button"
              [copyToClipboard]="profile.fullName"
              [copyInfo]="'copied_sepa_from_to_clipboard' | translate">
              <span class="bpi__icon-clipboard"></span>
            </a>
            <bp-info class="reference-info" full>{{ "sepa_from_small_info_text" | translate }}</bp-info>
          </bp-input>
        }
        @if (profile.business.getBusinessName().length > 0) {
          <bp-input
            [value]="profile.business.getBusinessName()"
            readonly
            disabled
            >
            <a
              right
              class="action-button"
              [copyToClipboard]="profile.business.getBusinessName()"
              [copyInfo]="'copied_sepa_company_name_to_clipboard' | translate">
              <span class="bpi__icon-clipboard"></span>
            </a>
            <bp-info class="reference-info" full>{{ "sepa_your_company_name" | translate }}</bp-info>
          </bp-input>
        }
        <bp-input [label]="'sepa_recipient' | translate" [value]="sepa?.getReceiver()" readonly disabled>
          <a
            right
            class="action-button"
            [copyToClipboard]="sepa?.getReceiver()"
            [copyInfo]="'copied_sepa_recipient_to_clipboard' | translate">
            <span class="bpi__icon-clipboard"></span>
          </a>
        </bp-input>
        @if (isGBPBankTransfer) {
          <bp-input
            [label]="'sepa_account_number' | translate"
            [value]="sepa?.getAccountNumber()"
            readonly
            disabled>
            <a
              right
              class="action-button"
              [copyToClipboard]="sepa?.getAccountNumber()"
              [copyInfo]="'copied_sepa_account_number_to_clipboard' | translate">
              <span class="bpi__icon-clipboard"></span>
            </a>
          </bp-input>
          <bp-input [label]="'sepa_sort_code' | translate" [value]="sepa?.getSortCode()" readonly disabled>
            <a
              right
              class="action-button"
              [copyToClipboard]="sepa?.getSortCode()"
              [copyInfo]="'copied_sepa_sort_code_to_clipboard' | translate">
              <span class="bpi__icon-clipboard"></span>
            </a>
          </bp-input>
        } @else {
          <bp-input [label]="'iban' | translate" [value]="sepa?.getIban()" readonly disabled>
            <a
              right
              class="action-button"
              [copyToClipboard]="sepa?.getIban()"
              [copyInfo]="'copied_iban_to_clipboard' | translate">
              <span class="bpi__icon-clipboard"></span>
            </a>
            <bp-info class="reference-info" full>
              {{ "sepa_iban_small_info_text" | translate: [fiat?.getSymbol()] }}
            </bp-info>
          </bp-input>
        }
        @if (amount > 0) {
          <bp-input
            [label]="'reference_amount' | translate"
            readonly
            disabled
            [value]="amount | fiat_precision_symbol: { id: fiat?.getId(), currencies: [fiat] }">
            <a
              right
              class="action-button"
              [copyToClipboard]="amount"
              [copyInfo]="'copied_amount_to_clipboard' | translate">
              <span class="bpi__icon-clipboard"></span>
            </a>
          </bp-input>
        }
      </div>
      <div class="sepa-details-infos">
        <div class="sepa-details-info-box info-box">{{ "reference_info" | translate }}</div>
        @if (!isGBPBankTransfer) {
          <div class="sepa-details-qr-code-container">
            <qrcode
              class="sepa-details-qr-code"
              [qrdata]="qrValue"
              [width]="200"
              [errorCorrectionLevel]="'H'"
            [allowEmptyString]="true"></qrcode>
            <bp-info class="reference-info" full>{{ "sepa_qr_code_description" | translate }}</bp-info>
          </div>
        }
      </div>
    </section>
    <hr class="divider-light-gray-fat" />
    <!-- Bank details -->
    <section class="sepa-details">
      <div class="sepa-details-list">
        <bp-input [label]="'sepa_bank_name' | translate" [value]="sepa?.getBank()" readonly disabled>
          <a
            right
            class="action-button"
            [copyToClipboard]="sepa?.getBank()"
            [copyInfo]="'copied_bank_name_to_clipboard' | translate">
            <span class="bpi__icon-clipboard"></span>
          </a>
        </bp-input>
        @if (!isGBPBankTransfer) {
          <bp-input
            [label]="'sepa_bic' | translate"
            [value]="sepa?.getBic()"
            readonly
            disabled>
            <a
              right
              class="action-button"
              [copyToClipboard]="sepa?.getBic()"
              [copyInfo]="'copied_bic_to_clipboard' | translate">
              <span class="bpi__icon-clipboard"></span>
            </a>
          </bp-input>
        }
        <bp-input [label]="'sepa_bank_address' | translate" [value]="sepa?.getBankAddress()" readonly disabled>
          <a
            right
            class="action-button"
            [copyToClipboard]="sepa?.getBankAddress()"
            [copyInfo]="'copied_bank_address_to_clipboard' | translate">
            <span class="bpi__icon-clipboard"></span>
          </a>
        </bp-input>
        <bp-input
          [label]="'sepa_receiver_address' | translate"
          [value]="sepa?.getReceiverAddress()"
          readonly
          disabled>
          <a
            right
            class="action-button"
            [copyToClipboard]="sepa?.getReceiverAddress()"
            [copyInfo]="'copied_receiver_address_to_clipboard' | translate">
            <span class="bpi__icon-clipboard"></span>
          </a>
        </bp-input>
      </div>
      @if (showNonEuInfo) {
        <div class="sepa-details-infos">
          <div class="mb-15">
            {{ "sepa_reference_info_non_eu_deposits" | translate }}
          </div>
          <div class="sepa-details-info-box info-box">
            {{ "sepa_reference_info_non_eu_deposits_infobox" | translate }}
          </div>
        </div>
      }
    </section>
  </div>
}
